import { createSectionTitle, createSummaryTitle, createTable, parseHtmlContent } from '../utils';

export const renderPastMedicalHistory = (data, title) => {
  const content = [createSectionTitle(title)];

  // Handle noDetails case
  if (data && data.noDetails) {
    content.push({
      text: 'No details',
      style: 'narrative',
      margin: [0, 0, 0, 8]
    });
    return content;
  }

  // Helper function to check if history data is meaningful
  const hasValidHistoryData = (data) => {
    if (!data || typeof data !== 'object') return false;

    const historyFields = [
      { status: data.chronic?.illness, note: data.chronic?.note },
      { status: data.surgeries?.surgery, note: data.surgeries?.note },
      { status: data.allergies?.allergy, note: data.allergies?.note },
      { status: data.hospitalization?.illnessOrInjury, note: data.hospitalization?.note }
    ];

    const hasValidFields = historyFields.some(
      (field) => (field.status && field.status !== '') || (field.note && field.note.trim() !== '')
    );

    const hasNarrative = data.narrative && data.narrative.trim() !== '';

    return hasValidFields || hasNarrative;
  };

  // Check if there's any meaningful data to display
  if (!hasValidHistoryData(data)) {
    content.push({
      text: 'No data',
      style: 'narrative',
      margin: [0, 0, 0, 8]
    });
    return content;
  }

  const historyFields = [
    {
      category: 'Chronic',
      status: data.chronic?.illness === 'yes' ? 'Yes' : data.chronic?.illness === 'no' ? 'No' : '',
      note: data.chronic?.note || ''
    },
    {
      category: 'Surgeries',
      status:
        data.surgeries?.surgery === 'yes' ? 'Yes' : data.surgeries?.surgery === 'no' ? 'No' : '',
      note: data.surgeries?.note || ''
    },
    {
      category: 'Allergies',
      status:
        data.allergies?.allergy === 'yes' ? 'Yes' : data.allergies?.allergy === 'no' ? 'No' : '',
      note: data.allergies?.note || ''
    },
    {
      category: 'Hospitalization',
      status:
        data.hospitalization?.illnessOrInjury === 'yes'
          ? 'Yes'
          : data.hospitalization?.illnessOrInjury === 'no'
            ? 'No'
            : '',
      note: data.hospitalization?.note || ''
    }
  ];

  const rows = historyFields
    .filter(
      (field) =>
        (field.status && field.status.trim() !== '') || (field.note && field.note.trim() !== '')
    )
    .map((field) => [
      { text: field.category, style: 'tableHeader' },
      { text: field.status, style: 'tableCell' },
      { text: field.note, style: 'tableCell' }
    ]);

  if (rows.length > 0) {
    content.push(createTable(['Category', 'Status', 'Note'], rows, ['25%', '15%', '60%']));
  }

  // Show narrative if it exists
  if (data.narrative && data.narrative.trim() !== '') {
    content.push(createSummaryTitle());
    content.push({
      text: parseHtmlContent(data.narrative),
      style: 'narrative',
      margin: [0, 0, 0, 8]
    });
  }

  // If no content was added beyond title, show "No data"
  if (content.length === 1) {
    content.push({
      text: 'No data',
      style: 'narrative',
      margin: [0, 0, 0, 8]
    });
  }

  return content;
};
